<script lang="ts" setup>
import { defineProps } from "vue";

import { ElTable } from "element-plus";
import { ElTableColumn } from "element-plus";

const props = defineProps<{
  data: Record<string, any>;
  columns: Record<string, any>;
}>();
</script>

<template>
  <div class="vi-table">
    <ElTable :data="props.data" style="width: 100%">
      <ElTableColumn
        v-for="column of props.columns"
        :key="column.label"
        :prop="column.accessor"
        :label="column.label"
      />
    </ElTable>
  </div>
</template>

<style lang="scss" scoped>
.vi-table {
  width: 100%;

  :deep(thead) {
    font-size: 16px;
    font-weight: 400;
    color: #8b8fa1;
  }

  :deep(.el-table__header-wrapper) {
    padding-top: 12px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f1f5;
  }
}
</style>
